import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, OnChanges, OnDestroy } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ReactiveFormService } from '../../services/reactive-form.service';


@Component({
    selector: 'kt-input-chip',
    templateUrl: './chip.component.html',
    styleUrls: ['./chip.component.scss']
})
export class ChipComponent implements OnInit, OnChanges, OnDestroy {
    @Input() fieldObj: any;
    @Input() options;
    @Input() values;

    @Input() form: FormGroup;
    @Output() valueChange = new EventEmitter<any>();

    isHideExpression = false;
    subscriptions: Subscription[] = [];

    constructor(public formService: ReactiveFormService) { }

    ngOnInit() {
        this.setValidations();
        this.hideExpression();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.values && changes.values.currentValue) {
            this.form.get(this.fieldObj.key).setValue(changes.values.currentValue);
        }

        if (changes && changes.options && changes.options.currentValue) {
            this.options = changes.values.currentValue;
        }
    }


    notifyChange() {
        if (this.form && this.fieldObj.key && this.form.controls[this.fieldObj.key].value) {
            this.valueChange.emit({ key: this.fieldObj.key, value: this.form.controls[this.fieldObj.key].value });
        }
    }


    hideExpression() {
        if (this.fieldObj && this.fieldObj.hideExpression && this.fieldObj.hideExpression.fieldName) {
            this.clearValidations();
            this.subscriptions.push(this.form.controls[this.fieldObj.hideExpression.fieldName].valueChanges.subscribe(val => {
                if (this.fieldObj.hideExpression.fieldValue === this.formService.matchValueExpression(val)) {
                    this.isHideExpression = false;
                    this.setValidations();
                } else {
                    this.clearValidations();
                }
            }));
        }
    }

    setValidations() {
        this.form.controls[this.fieldObj.key].validator =
            Validators.compose([this.fieldObj.required ?
                Validators.required : null, Validators.minLength(this.fieldObj.min_length),
            Validators.maxLength(this.fieldObj.max_length)]);
    }

    clearValidations() {
        this.isHideExpression = true;
        this.form.controls[this.fieldObj.key].clearValidators();
        this.form.controls[this.fieldObj.key].updateValueAndValidity();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

}
